// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_36d340a","toggleContainer":"_d051672","submit":"_8dc9f36"};